import { useCommonStore } from "@/stores/useCommonStore";
const customPlugin = {
    install(app) {
        const cmmonStorage = useCommonStore();
        app.config.globalProperties.$customPlugin = {
            redAlert(title, timeout = 5000) {
                cmmonStorage.setRedToastMessage(title, timeout);
            },
            greenAlert(title, timeout = 5000) {
                cmmonStorage.setGreenToastMessage(title, timeout);
            },
        };
    },
};
export default customPlugin;
